import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

/**
 * Account — mirrors the iOS ACCOUNT section: Subscription +
 * Data & Privacy. Phase B/D wires: GET /api/v1/billing/subscription
 * (read-only tier on web — purchases stay in iOS StoreKit until web
 * billing exists) · data export estimate/request/status under
 * /api/v1/users/me/data-export(s) · POST /api/v1/users/me/soft-delete
 * · POST|DELETE /api/v1/users/me/hard-delete-request.
 */
export const Route = createFileRoute("/account")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Account",
    "Your subscription, data export, and account controls — all from the web. We're building this surface now.",
  ),
});
